import ServiceContent from "@/model/Content/ServiceContent"

export interface IFoodServiceContent {}

class FoodServiceContent extends ServiceContent implements IFoodServiceContent {

    constructor() {
        super()
    }

}

export default FoodServiceContent